var map = {
	"./ag-default.png": "W4Oo",
	"./bb-default.png": "fRTk",
	"./ob-default.png": "mAwT",
	"./og-default.png": "rBk4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xpDl";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video ^\.\/.*\-default\.png$
// module id = xpDl
// module chunks = 3